import { render, staticRenderFns } from "./add-videoswebinars-modal.vue?vue&type=template&id=299973a4&scoped=true"
import script from "./add-videoswebinars-modal.vue?vue&type=script&lang=js"
export * from "./add-videoswebinars-modal.vue?vue&type=script&lang=js"
import style0 from "./add-videoswebinars-modal.vue?vue&type=style&index=0&id=299973a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299973a4",
  null
  
)

export default component.exports